import { PictoTypes } from "@/generated/classes/Module";
import { NotifDefTypes } from "@/generated/classes/NotifDef";

export function getPicto (value: string): string {
  try {
    return require('@/assets/SVG/' + value + '.svg');
  } catch (e) {
    return require('@/assets/SVG/undefined.svg');
  }
}


export function typePicto(type: number): string {
  let res = "";
  if (type == PictoTypes.IMAGE) {
    res = "image";
  } else if (type == PictoTypes.ICON) {
    res = "icon";
  } else if (type == PictoTypes.INITIAL) {
    res = "computed";
  }
  return res;
}

export function getNotifPicto (picto: string, notifDefType: NotifDefTypes): string {
  let res = picto;
  if (notifDefType == NotifDefTypes.INFO) {
    res = res + 'Green';
  } else if (notifDefType == NotifDefTypes.ACTION) {
    res = res + 'Red';
  }
  return res;
}
